import React from "react";
import { useTranslation } from "react-i18next";

import { ReactComponent as HelpIcon } from "images/icons/help-outline.svg";

import styles from "./style.module.scss";

type HelpTooltipType =
  | "note"
  | "quiz"
  | "record_lecture"
  | "flashcard"
  | "snapshot"
  | "video"
  | "podcast"
  | "lesson"
  | "game";

interface HelpTooltipProps {
  type: HelpTooltipType;
}

const HelpTooltip: React.FC<HelpTooltipProps> = ({ type}) => {
  const { t } = useTranslation();

  return (
    <div className={`${type}`}>
      <div
        className={`help-tooltip h-7 w-7 flex items-center justify-center rounded-full bg-stone-50 dark:bg-zeus-800 dark:hover:bg-zeus-900 dark:text-white`}
        data-tooltip={t(`shared.help_tooltip.${type}`)}
      >
        <HelpIcon className="w-4 h-4 text-black dark:text-white fill-black dark:fill-white" />
      </div>
    </div>
  );
};

export default HelpTooltip;

